import { FC } from "react";
import Modal from "react-modal";
import "./newModalWhatsApp.css";
import api from "../../services/api";
import { usePluginspace } from "../../hooks/usePluginspace";
import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


type Props = {
    isOpen: boolean;
    setIsOpen: (value: boolean) => void;
    backgroundButton?: string;
    fontButton?: string;
    whatNumber: string
    pluginName: string;
}


const NewModalWhatsApp: FC<Props> = ({
    isOpen,
    setIsOpen,
    backgroundButton = "#25D366",
    fontButton = "#fff",
    whatNumber,
    pluginName
}) => {
    const { getToken } = usePluginspace();
    const waNumber = `55${whatNumber.replace(/\D/g, "")}`;

    if (!isOpen) {
        return null;
    }

    const handleOpenWhatsApp = () => {
        let text = 'Ativar recebimento de mensagens do'
        window.open(`https://wa.me/${waNumber}?text=${text} ${pluginName}`, "_blank");
    };

    const sendOptIn = async () => {
        try {
            const response: any = await api.post(
                `/api/zapnis-web/`,
                {
                    headers: {
                        Authorization: `Bearer ${await getToken()}`,
                    },

                }
            );

            if (response && response.success) {
                toast.success(
                    "Optin Aceito com sucesso",
                    {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                        theme: "light",
                        transition: Slide,
                    }
                );
            }


        } catch (error) {
            toast.error(
                "Falha ao cadastrar optIn",
                {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: "light",
                    transition: Slide,
                }
            );
        } finally {
            handleClose();
        }
    }

    const handleClose = () => {
        setIsOpen(false);
    };

    return (

        <Modal
            isOpen={isOpen}
            onRequestClose={() => setIsOpen(false)}
            className="modal-content-whatsapp"
            contentLabel="WhatsApp Notification Modal"
            overlayClassName="ReactModal__Overlay"
            ariaHideApp={false}
        >

            <div className="modal-content-whatsapp">
                <div className="modal-header-whatsapp">
                    <h2>Receba notificações via WhatsApp</h2>
                </div>

                <div className="modal-body-whatsapp">
                    <div className="steps-container">
                        <div className="step">
                            <span className="step-number">1</span>
                            <p>Clique no botão abaixo para aceitar receber mensagens pelo WhatsApp.</p>
                        </div>

                        <div className="step">
                            <span className="step-number">2</span>
                            <p>Pronto! Você receberá informações e avisos da loja automaticamente.</p>
                        </div>
                    </div>

                    <div className="footer-message">
                        <p>Agradecemos por escolher nossa Loja.</p>
                    </div>
                </div>

                <div className="modal-footer-whatsapp">
                    <button
                        className="btn-whatsapp-open"
                        onClick={sendOptIn}
                        style={{ backgroundColor: backgroundButton, color: fontButton }}
                    >
                        Aceito
                    </button>

                    <div className="button-group">
                        <button
                            className="btn-close"
                            onClick={handleClose}
                        >
                            Fechar
                        </button>



                    </div>
                </div>
            </div>
        </Modal >
    )
}

export default NewModalWhatsApp;